module.exports = __webpack_public_path__ + "img/product_46.8b76130.webp";